var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOncology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "10,4.4 13,6.1 13.6,2.6  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 13,
    y1: 6.1,
    x2: 15,
    y2: 11.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "22.2,4.6 22.4,8 25.7,6.7  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 22.4,
    y1: 8,
    x2: 19.1,
    y2: 12.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "28.8,11.6 26.5,14.2 29.8,15.5  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 26.5,
    y1: 14.2,
    x2: 21.1,
    y2: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "27.4,20.8 23.9,20.4 24.8,23.8  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 23.9,
    y1: 20.4,
    x2: 20.1,
    y2: 16.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "2.2,13.5 5.4,12.1 3.1,9.5  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 5.4,
    y1: 12.1,
    x2: 10.7,
    y2: 13.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "4.7,22.2 6.2,19.1 2.7,18.7  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 6.2,
    y1: 19.1,
    x2: 11.2,
    y2: 16.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "12.8,28.5 11.3,25.4 8.8,27.8  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 11.3,
    y1: 25.4,
    x2: 12.8,
    y2: 20.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "20.7,27.2 17.7,25.4 17,28.9  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 17.7,
    y1: 25.4,
    x2: 15.8,
    y2: 20.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.9,16.5c0-0.7-0.3-1.4-0.7-1.9 c0.2-0.4,0.4-0.9,0.4-1.4c0-1.6-1.2-2.8-2.8-2.9c-0.1-1.8-1.6-3.1-3.4-3.1c-1.4,0-2.6,0.9-3.2,2.1c-0.5-0.3-1-0.4-1.6-0.4 c-1.9,0-3.4,1.5-3.4,3.4c0,0.4,0.1,0.9,0.2,1.2c-0.6,0.5-1,1.4-1,2.3c0,0.8,0.3,1.6,0.9,2.1c-0.5,0.5-0.7,1.2-0.7,1.9 c0,1.6,1.3,3,3,3c0.3,0,0.5,0,0.7-0.1c0.3,1,1.2,1.8,2.3,1.8c1,0,1.9-0.6,2.2-1.5c0.2,0.1,0.4,0.1,0.7,0.1c0.7,0,1.3-0.3,1.8-0.8 c0.3,0.2,0.7,0.3,1.2,0.3c1.3,0,2.4-1.1,2.4-2.4c0-0.4-0.1-0.9-0.3-1.2C23.3,18.5,23.9,17.6,23.9,16.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 12.3,
    cy: 11.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 15.1,
    cy: 13.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 18.1,
    cy: 14.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 15.1,
    cy: 16.1,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 14,
    cy: 18.4,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 17.7,
    cy: 17.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 17.5,
    cy: 10.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 20.9,
    cy: 13.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 11,
    cy: 19.6,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 10.6,
    cy: 15.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 21.4,
    cy: 16.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 17.5,
    cy: 21.3,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 20.3,
    cy: 20.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 14.4,
    cy: 21.8,
    r: 1.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 24,
    cy: 21.6,
    r: 4.1
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "26.7,20.5 25.1,20.5 25.1,18.9  22.9,18.9 22.9,20.5 21.3,20.5 21.3,22.7 22.9,22.7 22.9,24.3 25.1,24.3 25.1,22.7 26.7,22.7  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOncology);
export default __webpack_public_path__ + "static/media/oncology.64565cebc2ce0c95ddebe8df61728ade.svg";
export { ForwardRef as ReactComponent };